(function () {
  function loadCollectionGrid(collectionHandle) {
    const container = document.getElementById("slideshow-products");
    if (!collectionHandle || !container) return;

    fetch(
      `/collections/${collectionHandle}?section_id=slideshow-collection-grid`
    )
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const grid = doc.querySelector(".grid");
        container.innerHTML = "";

        if (grid) {
          container.innerHTML = ""; // Clear old content

          // Create wrapper for the entire section
          const sectionWrapper = document.createElement("div");
          sectionWrapper.className = "collection-display-wrapper";

          // Create a separate wrapper for the button
          const viewAllWrapper = document.createElement("div");
          viewAllWrapper.className = "view-all-wrapper";

          const viewAllLink = document.createElement("a");
          viewAllLink.href = `/collections/${collectionHandle}`;
          viewAllLink.textContent = "View All";
          viewAllLink.className = "view-all-link button button--simple";

          viewAllWrapper.appendChild(viewAllLink);

          // Grid container
          const gridWrapper = document.createElement("div");
          gridWrapper.className = "collection-grid-wrapper";
          gridWrapper.appendChild(grid);

          // Combine everything
          sectionWrapper.appendChild(viewAllWrapper);
          sectionWrapper.appendChild(gridWrapper);
          container.appendChild(sectionWrapper);
        }
      });

    console.log("Loading:", collectionHandle);
  }

  const slideshow = () => {
    $(".slideshow-section").each(function () {
      if ($(this).hasClass("slider_started")) return;

      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".slideshow");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;

      const autoplayParm = autoplay
        ? {
            autoplay: {
              delay: delay,
              pauseOnMouseEnter: stopAutoplay,
              disableOnInteraction: false,
            },
          }
        : {};

      const swiperParms = {
        parallax: box.data("parallax"),
        speed: box.data("speed") * 1000,
        effect: box.data("effect"),
        loop: false,
        centeredSlides: false,
        autoHeight: false,
        calculateHeight: false,
        keyboard: true,
        creativeEffect: {
          prev: {
            shadow: true,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParm,
      };

      const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);

      colorScheme(swiper);

      swiper.on("slideChange", function () {
        colorScheme(this);

        const activeSlide = swiper.slides[swiper.activeIndex];
        const collectionHandle = activeSlide.getAttribute(
          "data-collection-handle"
        );

        if (collectionHandle) {
          loadCollectionGrid(collectionHandle);
        }
      });

      function colorScheme(context) {
        const parent = $(context.el).parent();
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide)
          .find(".slideshow-slide")
          .data("color-scheme");
        changeItems.forEach((item) => {
          $(item)
            .removeClass("color-background-1 color-background-4")
            .addClass(colorScheme);
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    const firstSlide = document.querySelector(
      ".swiper-slide[data-collection-handle]"
    );
    if (firstSlide) {
      const collectionHandle = firstSlide.getAttribute(
        "data-collection-handle"
      );
      if (collectionHandle) loadCollectionGrid(collectionHandle);
    }

    document.addEventListener("shopify:section:load", function () {
      slideshow();
      const firstSlide = document.querySelector(
        ".swiper-slide[data-collection-handle]"
      );
      if (firstSlide) {
        const collectionHandle = firstSlide.getAttribute(
          "data-collection-handle"
        );
        if (collectionHandle) loadCollectionGrid(collectionHandle);
      }
    });
  });
})();
